module.exports = __webpack_public_path__ + "static/media/187.31faeabe.wav";